import { useMutation } from '@tanstack/react-query'
import Cookies from 'js-cookie'

import { useAppSelector } from '~/store'

type StockItem = {
    id: number
    name?: string
    barcode?: string | null
    buffer_threshold?: number
}

export async function updateStockItems(
    url: string,
    stockItems: StockItem[]
): Promise<{ count: number }> {
    const res = await fetch(url, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json; charset=utf-8',
            'X-CSRFToken': Cookies.get('csrftoken') ?? '',
        },
        body: JSON.stringify(stockItems),
    })

    if (!res.ok) {
        throw new Error('Failed to update stock items')
    }

    return await res.json()
}

export function useUpdateStockItemsMutation() {
    const bulkUpdateStockItemsAPIURL = useAppSelector(
        (state) => state.initial.endpoints.bulkUpdateStockItemsAPIURL
    )

    return useMutation({
        mutationFn: async (records: StockItem[]) => {
            return await updateStockItems(bulkUpdateStockItemsAPIURL, records)
        },
    })
}
